module.exports = __webpack_public_path__ + "static/media/details-19-image-4.768d98cd.jpg";